import { Provider } from '@angular/core';
import { ProductTypes } from 'products-data';
import { ItemStockLayout } from 'products-ui';
import { PunchoutItemStockProviderComponent } from 'punchout-ui';

export function providePunchoutLeadTimeFeature(): Provider[] {
  return [
    ...ItemStockLayout.provide({ type: ProductTypes.Wire, component: PunchoutItemStockProviderComponent }),
    ...ItemStockLayout.provide({ type: ProductTypes.Standard, component: PunchoutItemStockProviderComponent }),
  ];
}
